import { Agent } from 'src/interfaces/agent.interface';
import { PostCallPromptSection } from './PostCallPromptSection';
import { PostCallActionsSection } from './PostCallActionsSection';
import { PostCallActivityTracking } from './PostCallActivityTracking';
import { PostCallDataExtractionSection } from './PostCallDataExtractionSection';

type PostCallProps = {
  agent: Agent;
  setAgent: (value: React.SetStateAction<Agent>) => void;
  loading: boolean;
};

export const PostCall = ({ agent, setAgent, loading }: PostCallProps) => {
  const hasPostCallPrompt = !!agent.post_call_prompt?.trim();

  return (
    <div>
      {hasPostCallPrompt ? (
        <PostCallPromptSection
          agent={agent}
          setAgent={setAgent}
          loading={loading}
        />
      ) : (
        <PostCallDataExtractionSection
          agent={agent}
          setAgent={setAgent}
          loading={loading}
        />
      )}

      {/* Horizontal border separator */}
      <div className="flex items-center justify-center">
        <div className="w-full h-px bg-neutral-100 my-4"></div>
      </div>

      <PostCallActionsSection
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />

      {/* Horizontal border separator */}
      <div className="flex items-center justify-center">
        <div className="w-full h-px bg-neutral-100 my-4"></div>
      </div>

      <PostCallActivityTracking
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />
    </div>
  );
};
